<template>
  <div>
    <v-container>
      <div class="breadcrumb">
        <ul>
          <li v-for="(bc,i) in birth.breadcrumbs" :key="i" :class="{'linked': !!bc.link}">
            <router-link tag="li" :to="bc.link">
              <div v-if="i === birth.breadcrumbs.length -1">
                <a style="text-decoration: none; color: black; font-weight: bold;">{{bc.name}}</a>
              </div>
              <a v-else style="text-decoration: none; color: black;">{{bc.name}}</a>
            </router-link>
          </li>
        </ul>
      </div>
      <v-layout>
        <v-flex class="text-xs-center">
          <v-card raised>
            <div class="font-weight-light display-2">{{ birth.child_full_name}}</div>
            <v-layout row wrap style="padding: 20px;" v-if="birth.images.length">
              <div v-for="image in birth.images" :key="image.id">
                <v-flex class="text-md-center">
                  <v-img :src="image" width="260" contain />
                </v-flex>
              </div>
            </v-layout>
            <div v-else>
              <v-img :src="birth.photo" width="260" contain />
            </div>
            <v-layout row wrap>
              <v-flex sm12 v-if="birth.father">
                <strong>Padre:</strong>
                {{ birth.father }}
              </v-flex>
              <v-flex sm12 v-if="birth.mother">
                <strong>Madre:</strong>
                {{ birth.mother }}
              </v-flex>
              <v-flex sm12>
                <strong>Fecha de nacimiento:</strong>
                {{ birth.birthday_format_2 }}
              </v-flex>

              <br />
            </v-layout>
            <v-btn flat color="primary" @click="goToBirthsList">Volver</v-btn>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  data() {
    return {};
  },
  props: {
    birth: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapMutations("births", ["setBirth"]),
    goToBirthsList() {
      this.$router.push({
        name: "births"
      });
    }
  }
};
</script>

<style scoped>
ul {
  display: flex;
  justify-content: left;
  list-style-type: none;
}
ul > li {
  display: flex;
  float: left;
  width: auto;
  color: default;
  font-weight: bold;
  font-size: 1.2em;
  cursor: default;
  align-items: center;
}
ul > li:not(:last-child)::after {
  content: ">";
  float: right;
  font-size: 1.2em;
  margin: 0 0.5em;
  color: light-default;
  cursor: default;
}
.linked {
  cursor: pointer;
  font-size: 1.2em;
  font-weight: normal;
}
</style>
